import { useMemo } from "react";
import { FilePreviewDialog } from "@/components/FilePreviewDialog";

export const PayslipPdfDialog = ({ payslip, onClose }) => {
  const file = useMemo(() => (payslip
    ? { src: `/hr/payslips/${payslip.id}/file`, name: payslip.original_filename || "bulletin.pdf" }
    : null), [payslip]);
  return <FilePreviewDialog file={file} onClose={onClose} />;
};
